<div class="divHome">
  <div class="divButtons">
    <div class="top-controls">
      <div class="search-box">
        <i-tabler name="search" class="search-icon"></i-tabler>
        <input type="text" (keyup)="applyFilter($event)" placeholder="Buscar" />
      </div>
      <div class="action-actions">
        <button mat-stroked-button class="actualizar-btn" (click)="ngOnInit()">
          <i-tabler name="refresh" class="btn-icon"></i-tabler> Actualizar
        </button>
        <button
          mat-stroked-button
          class="filtros-btn"
          (click)="toggleFilters()"
        >
          <i-tabler name="filter" class="btn-icon"></i-tabler> Filtros
        </button>
      </div>
    </div>

    <div class="filters-panel" *ngIf="showFilters !== false">
      <div class="filter-column">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <label class="filter-label">Fecha de Creación</label>
          <a
            style="
              font-size: 12px;
              color: #f97316;
              cursor: pointer;
              text-decoration: underline;
            "
            *ngIf="startDate || endDate"
            (click)="cleanDateSelected()"
            >Quitar</a
          >
        </div>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate placeholder="Inicio" [(ngModel)]="startDate" />
            <input matEndDate placeholder="Fin" [(ngModel)]="endDate" />
          </mat-date-range-input>

          <mat-datepicker-toggle
            matSuffix
            [for]="rangePicker"
          ></mat-datepicker-toggle>

          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button
                style="background-color: rgb(184, 69, 18)"
                mat-raised-button
                color="primary"
                (click)="onApplyRangeSelected()"
                matDateRangePickerApply
              >
                Filtrar
              </button>

              <button
                mat-button
                matDateRangePickerCancel
                (click)="cleanDateSelected()"
              >
                Limpiar
              </button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="filter-column">
        <label class="filter-label">Tipo de Incidencia</label>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-select
            [(value)]="selectedOpIncidentType"
            (selectionChange)="applyFilterSelect()"
            placeholder="Tipo de Incidencia Operativa"
          >
            <mat-option value="{{ null }}">Todos</mat-option>
            <mat-option
              *ngFor="let opIncidentTypeOption of opIncidentTypeOptions"
              value="{{ opIncidentTypeOption }}"
              >{{ opIncidentTypeOption }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-column">
        <label class="filter-label">Estado</label>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-select
            [(value)]="selectedIncidentStatus"
            (selectionChange)="applyFilterSelect()"
            placeholder="Seleccionar"
          >
            <mat-option value="{{ null }}">Todos</mat-option>
            <mat-option
              *ngFor="let incidentState of opIncidentStatus"
              value="{{ incidentState }}"
              >{{ renameOpIncidentStatus(incidentState) }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-column">
        <label class="filter-label">Tipo de Servicio</label>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-select
            [(value)]="selectedServiceType"
            (selectionChange)="applyFilterSelect()"
            placeholder="Seleccionar"
          >
            <mat-option value="{{ null }}">Todos</mat-option>
            <mat-option
              *ngFor="let opIncidentServiceType of opIncidentServicesTypes"
              value="{{ opIncidentServiceType.value }}"
              >{{ opIncidentServiceType?.viewValue | titlecase }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <p class="results-text">
    <i-tabler name="info-circle" class="info-icon"></i-tabler>
    Se encontraron
    {{ opIncidentTableSource.filteredData?.length || 0 }} Incidencias
    Operativas.
  </p>

  <div
    class="table-wrapper"
    style="
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
    "
  >
    <div class="loading-overlay" *ngIf="isLoading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ loadingMessage }}</p>
    </div>

    <div class="error-message" *ngIf="hasError">
      <i-tabler name="alert-triangle"></i-tabler>
      <p>
        Error al cargar las incidencias operativas. Por favor, intenta de nuevo.
      </p>
      <ng-container *ngIf="textError">
        <p>{{ textError }}</p>
      </ng-container>
      <button mat-button color="primary" (click)="refreshData()">
        Reintentar
      </button>
    </div>

    <div class="table-container" style="border: none; border-radius: 0">
      <mat-table
        [dataSource]="opIncidentTableSource"
        matSort
        class="operativas-table"
      >
        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Fecha de <br />
            Creación</mat-header-cell
          >

          <mat-cell *matCellDef="let opIncidentRow">
            {{ opIncidentRow.createdAt | date: "dd/MM/yyy" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fileNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            File
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            {{ opIncidentRow.fileNumber }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nameClient">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Cliente
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            {{ opIncidentRow.nameClient }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="serviceName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Servicio</mat-header-cell
          >
          <mat-cell *matCellDef="let opIncidentRow">
            {{ opIncidentRow.serviceName || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="appendService">
          <mat-header-cell
            *matHeaderCellDef
            style="min-width: 50px; max-width: 50px; padding: 16px 8px"
          >
          </mat-header-cell>
          <mat-cell
            *matCellDef="let opIncidentRow"
            style="
              min-width: 50px;
              max-width: 50px;
              padding: 16px 8px;
              justify-content: center;
            "
          >
            <button
              mat-icon-button
              *ngIf="
                (!opIncidentRow.serviceName ||
                  opIncidentRow.serviceName === '-') &&
                (!opIncidentRow.serviceType ||
                  opIncidentRow.serviceType === '-')
              "
              (click)="openDialogAppendService(opIncidentRow)"
            >
              <i-tabler name="edit" class="icon-color"></i-tabler>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="serviceType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Tipo de Servicio</mat-header-cell
          >
          <mat-cell *matCellDef="let opIncidentRow">
            {{ (opIncidentRow.serviceType | titlecase) || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Descripción de Incidencia
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            <div class="description-cell">{{ opIncidentRow.description }}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="reportedBy">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Reportado por</mat-header-cell
          >
          <mat-cell *matCellDef="let opIncidentRow">
            {{ opIncidentRow.reportedBy }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ds">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            DS
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            {{ opIncidentRow.ds }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="opIncidentType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Tipo de Incidencia</mat-header-cell
          >
          <mat-cell *matCellDef="let opIncidentRow">
            {{ opIncidentRow.opIncidentType }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="incidentStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >Estado de <br />Incidencia</mat-header-cell
          >
          <mat-cell *matCellDef="let opIncidentRow">
            <div [ngClass]="opIncidentRow.incidentStatus" class="legend-badge">
              {{ renameOpIncidentStatus(opIncidentRow.incidentStatus) }}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="solutionDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Fecha de <br />Resolución
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            {{ (opIncidentRow.solutionDate | date: "dd/MM/YYYY") || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="solutionTime">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Tiempo de <br />Resolución
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            {{ opIncidentRow.solutionTime || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Acciones Realizadas
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            <div class="description-cell">
              {{ opIncidentRow.actions || "-" }}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="editar">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Editar <br />Incidencia
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            <button
              mat-icon-button
              color="primary"
              (click)="openDialogUpdateOpIncident(opIncidentRow)"
            >
              <i-tabler name="edit" class="icon-color"></i-tabler>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="addOpIncident">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Agregar <br />Incidencia
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            <button
              mat-icon-button
              color="primary"
              (click)="openDialogAddOpIncident(opIncidentRow)"
            >
              <i-tabler name="library-plus" class="icon-color"></i-tabler>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="eliminar">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Eliminar <br />Incidencia
          </mat-header-cell>
          <mat-cell *matCellDef="let opIncidentRow">
            <button
              mat-icon-button
              color="primary"
              (click)="openDialogDeleteOpIncident(opIncidentRow)"
            >
              <i-tabler name="trash" class="icon-color"></i-tabler>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="opIncidentColumns"></mat-header-row>
        <mat-row *matRowDef="let opIncidentRow; columns: opIncidentColumns">
        </mat-row>

        <tr class="mat-row empty-row" *matNoDataRow>
          <td
            class="mat-cell"
            [attr.colspan]="opIncidentColumns.length"
            *ngIf="!isLoading"
          >
            No se encontraron resultados para su búsqueda u otros filtros.
          </td>
        </tr>
      </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

  <div class="legend-card">
    <h3>Leyenda de Estado de Incidencias Operativas</h3>
    <div class="legend-items">
      <div class="legend-item">
        <span class="legend-badge CREATED">Creado</span>
        <span class="legend-label"
          >La incidencia operativa se creó en Biblia.</span
        >
      </div>
      <div class="legend-item">
        <span class="legend-badge IN_PROGRESS">En Proceso</span>
        <span class="legend-label"
          >La incidencia se encuentra en proceso de resolución.</span
        >
      </div>
      <div class="legend-item">
        <span class="legend-badge FINISHED">Solucionado</span>
        <span class="legend-label"
          >La incidencia fue solucionada por el equipo de Operaciones.</span
        >
      </div>
    </div>
  </div>
</div>
